import styled from "styled-components";

interface LiveStreamingNavigationProps {
    isActive: boolean;
}

const LiveStreamingNavigationCommonBox = styled.div<LiveStreamingNavigationProps>`
    position: absolute;
    top: 35%;
    width: 3rem;
    height: 3rem;
    opacity: ${({isActive}) => isActive ? "1" : "0.25"};
`;

export const LiveStreamingNavigationPrevButtonDefaultBox = styled(LiveStreamingNavigationCommonBox)`
    left: 1rem;
`;

export const LiveStreamingNavigationNextButtonDefaultBox = styled(LiveStreamingNavigationCommonBox)`
    right: 1rem;
`;
